import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-columns-dialog',
    templateUrl: './columns-dialog.component.html',
    styleUrls: ['./columns-dialog.component.scss'],
    standalone: false
})
export class ColumnsDialogComponent implements OnInit {
   selectedFields: string[];
   backgroundColorButton: string;
   buttonColor = '';
   titleText = 'Choose Columns';

  constructor(public dialogRef: MatDialogRef<ColumnsDialogComponent>,private localStorage: LocalStorageSettingsService,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.selectedFields = [...data.selectedFields];
    }
     ngOnInit(): void {
     this.backgroundColorButton = this.localStorage.getSettings('ColorA');
  }

save() {
    this.dialogRef.close(this.selectedFields);
  }

  selectAll() {
    this.selectedFields = this.data.toggleableCols.map((c: any) => c.field);
  }

  clearAll() {
    this.selectedFields = [];
  }

}
